import { useQuery } from "@apollo/client"
import { gql } from "~/__generated__"
import { TablePageLayout } from "~/layouts/table-page-layout"
import { Button } from "~/ui/button"
import { GraphqlError } from "~/ui/errors"
import { columns } from "~/admin/locations/admin-locations-columns" // Use admin columns
import { DataTable } from "~/admin/data-table"
import { Routes, Route, Link } from "react-router-dom"
import { LocationEditScreen } from "./location-edit-screen"
import { LocationDetailsScreen } from "./location-details-screen"
import { LocationNewScreen } from "./location-new-screen"

export const locationsQuery = gql(/* GraphQL */ `
  query Locations($first: Int = 20, $after: String) {
    locations(first: $first, after: $after) {
      edges {
        node {
          id
          name
          status
          websiteUrl
          googleMapsUrl
          latitude
          longitude
          streetAddress
          streetAddress2
          city
          stateProvince
          postalCode
          country
          formattedAddress
          placeId
          administrativeAreaLevel1
          administrativeAreaLevel2
          neighborhood
          phone
          timeZone
          createdAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`)

export const LocationsListScreen = () => {
  const { data, fetchMore, error } = useQuery(locationsQuery)

  if (error) {
    return <GraphqlError error={error} />
  }

  const locations = data?.locations.edges.map((edge) => edge?.node) ?? []
  const pageInfo = data?.locations.pageInfo

  return (
    <Routes>
      <Route path="new" element={<LocationNewScreen />} />
      <Route path=":id/edit" element={<LocationEditScreen />} />
      <Route path=":id" element={<LocationDetailsScreen />} />
      <Route
        index
        element={
          <TablePageLayout>
            <div className="flex items-center justify-between">
              <h1 className="text-2xl">Locations</h1>
              <Link to="/locations/new">
                <Button variant="outline">New Location</Button>
              </Link>
            </div>
            <hr className="my-4 border-0 border-b" />
            <DataTable columns={columns} data={locations} />
            {pageInfo && pageInfo.hasNextPage && (
              <>
                <hr className="my-4 border-0 border-b" />
                <div className="flex gap-2">
                  <Button
                    variant="outline"
                    className="disabled:bg-gray-100"
                    onClick={() => {
                      fetchMore({
                        variables: {
                          after: pageInfo.endCursor,
                        },
                      })
                    }}
                    disabled={!pageInfo.hasNextPage}
                  >
                    Load more
                  </Button>
                </div>
              </>
            )}
          </TablePageLayout>
        }
      />
    </Routes>
  )
}
